import React from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'

import {Alert} from '@/components'
import {THasClassName} from '@/types'

export const EmptyBankAccounts = observer(({className}: THasClassName) => {
    const { t } = useTranslation()
    return (
        <Alert
            className={className}
            title={t('ChangeBankAccountDetails.labels.noBankAccount')}
            description={t('ChangeBankAccountDetails.labels.addBankAccountInstructions')}
            type='warning'
        />
    )
})
